import Angular from "angular";
import Template from "./day-calendar.html";
import Controller from "./calendar.controller.js";
import CalendarItem from "./calendar-item";

let DayCalendarModule = Angular.module('day-calendar', [CalendarItem.name])

    .component('dayCalendar', {
        template: Template,
        controller: Controller,
        transclude: {
            'calendarItemContent': '?calendarItemContent'
        },
        bindings: {
            calendar: '<',
            onItemTap: '&',
            zoom: '<',
            minZoom: '<',
            maxZoom: '<'
        }
    });

export default DayCalendarModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/day-calendar.js